import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "agents-table-nav mt-[16px] gap-[12px]" }
const _hoisted_2 = { class: "flex agents-nav-items ml-auto flex-nowrap gap-[12px] nav-status-bar-close-mode" }

import AgentQuickFilterDropdown from '@/components/agents-table/AgentQuickFilterDropdown.vue';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import CloudUnlock from '@/components/common/userNotifications/components/cloud-unlock.vue';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import AgentRowHeightButton from '@/views/agents/components/agentRowHeightButton.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { CLOUD_STATUS, OFFLINE_STATUSES } from '@/views/settings/settingsCloud/cloud.const';
import { inject, computed } from 'vue';
import { useOsService } from '@/services/OsService/OsService';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import NavBarSearchInput from '../components/nav-bar-search-input.vue';
import NavBarFilterBtn from '../components/nav-bar-filter-btn.vue';
import NavBarMultipleActionsBtn from '../components/nav-bar-multiple-actions-btn.vue';
import EditTable from '../../../edit-table/edit-table.vue';
import ManageBuildGroups from '../../../manage-build-groups-btn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-nav-bar-list.linux',
  setup(__props) {

const coordinatorService = inject(IKCoordinatorsService);
const agentsFilter = inject(IKAgentsDrawerFilter);
const osService = useOsService();
const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorService?.selectedCoordinator.value || '' }));
const cloudStatus = computed(() => (GQL_commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus as CLOUD_STATUS) || CLOUD_STATUS.Disabled);
const userRolePermissions = useUserRolePermissions();
const cloudIsOffline = computed(() => OFFLINE_STATUSES.has(cloudStatus.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(NavBarMultipleActionsBtn),
        _createVNode(NavBarFilterBtn),
        _createVNode(AgentQuickFilterDropdown, {
          class: "table-upper-buttons",
          "quick-filter-state": _unref(agentsFilter)?.filter.value.quickFilter
        }, null, 8, ["quick-filter-state"]),
        _createVNode(NavBarSearchInput),
        _createElementVNode("div", _hoisted_2, [
          (_unref(userRolePermissions).authorize?.value?.agents?.visible?.buildGroupsButton)
            ? (_openBlock(), _createBlock(ManageBuildGroups, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(EditTable),
          _createVNode(AgentRowHeightButton),
          (_unref(osService)?.isLinux.value && _unref(userRolePermissions).authorize?.value?.cloud.visible.unlockCloud && _unref(cloudIsOffline))
            ? (_openBlock(), _createBlock(CloudUnlock, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})